import { MdCancel } from "react-icons/md";

const getEmailText = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean).join(", ") || "NA";
  return value || "NA";
};

export const RequestsSectionContent = ({ records }) => (
  <div className="adp-table-wrap">
    <table className="adp-files-event-table adp-request-list-table">
      <thead>
        <tr>
          <th>Vin Id</th>
          <th>Request Type</th>
          <th>Request Email Address</th>
          <th>Response Type</th>
          {/* <th>Response Email Address</th> */}
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {records.map((record, index) => (
          <tr key={record.id || `request-${index}`}>
            <td>{record.vinId}</td>
            <td>{record.requestMethod?.requestType || "NA"}</td>
            <td>
              <span className="adp-ellipsis-text" title={getEmailText(record.requestMethod?.emailSettings)}>
                {getEmailText(record.requestMethod?.emailSettings)}
              </span>
            </td>
            <td>{record.responseMethod?.responseType || "NA"}</td>
            {/* <td>
              <span className="adp-ellipsis-text" title={getEmailText(record.responseMethod?.emailSettings)}>
                {getEmailText(record.responseMethod?.emailSettings)}
              </span>
            </td> */}
            <td>{record.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const RequestsModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="adp-section-modal-overlay" >
      <div className="adp-section-modal" >
        <div className="adp-section-modal-header">
          <span>Requests</span>
          <button className="adp-section-modal-close" type="button" onClick={onClose} aria-label="Close Requests">
            <MdCancel size={25} />
          </button>
        </div>
        <div className="adp-section-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default RequestsModal;
